<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<div class="ngf-control" [class.ngf-control-invalid]="hasErrors$ | async">
  <div class="ngf-control__header">
    <ngf-control-label-container [required]="formControls$ | async | isAnyRequired">
      <ng-content select="label"></ng-content>
      <ng-content select="mat-icon"></ng-content>
    </ngf-control-label-container>
  </div>

  <div class="ngf-control__main">
    <ng-content></ng-content>
  </div>

  <div class="ngf-control__footer">
    <ng-content select="ngf-control-hint"></ng-content>
    <ng-content select="ngf-control-error"></ng-content>
    <ng-content select="ngf-control-misc"></ng-content>
  </div>
</div>
